module.exports = __webpack_public_path__ + "img/bg-login.455f2c52.png";